/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CustomerDataCreate } from '../models';
// @ts-ignore
import type { CustomerDataImport } from '../models';
// @ts-ignore
import type { CustomerDataOut } from '../models';
// @ts-ignore
import type { CustomerDataUpdate } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PaginatedCustomerDataOut } from '../models';
/**
 * CustomerDataApi - axios parameter creator
 * @export
 */
export const CustomerDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new customer data (with optional TTL).
         * @param {CustomerDataCreate} customerDataCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerData: async (customerDataCreate: CustomerDataCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerDataCreate' is not null or undefined
            assertParamExists('createCustomerData', 'customerDataCreate', customerDataCreate)
            const localVarPath = `/api/v1/customer-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerDataCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete customer data by ID.
         * @param {number} contextId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerData: async (contextId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contextId' is not null or undefined
            assertParamExists('deleteCustomerData', 'contextId', contextId)
            const localVarPath = `/api/v1/customer-data/{context_id}`
                .replace(`{${"context_id"}}`, encodeURIComponent(String(contextId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all unique attributes from customer data.
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAttributes: async (agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customer-data/all-attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all customer data (no pagination).
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerData: async (agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customer-data/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all unique tags from customer data.
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTags: async (agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customer-data/all-tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated list of customer data with filter & sort.
         * @param {string | null} [agentId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [keyword] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerData: async (agentId?: string | null, page?: number, pageSize?: number, keyword?: string | null, orderBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customer-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customer data by ID.
         * @param {number} contextId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDataDetail: async (contextId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contextId' is not null or undefined
            assertParamExists('getCustomerDataDetail', 'contextId', contextId)
            const localVarPath = `/api/v1/customer-data/{context_id}`
                .replace(`{${"context_id"}}`, encodeURIComponent(String(contextId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk import multiple customer data records.
         * @param {Array<CustomerDataImport>} customerDataImport 
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomerData: async (customerDataImport: Array<CustomerDataImport>, agentId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerDataImport' is not null or undefined
            assertParamExists('importCustomerData', 'customerDataImport', customerDataImport)
            const localVarPath = `/api/v1/customer-data/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)

            if (agentId !== undefined) {
                localVarQueryParameter['agent_id'] = agentId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerDataImport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update existing customer data by ID.
         * @param {number} contextId 
         * @param {CustomerDataUpdate} customerDataUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerData: async (contextId: number, customerDataUpdate: CustomerDataUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contextId' is not null or undefined
            assertParamExists('updateCustomerData', 'contextId', contextId)
            // verify required parameter 'customerDataUpdate' is not null or undefined
            assertParamExists('updateCustomerData', 'customerDataUpdate', customerDataUpdate)
            const localVarPath = `/api/v1/customer-data/{context_id}`
                .replace(`{${"context_id"}}`, encodeURIComponent(String(contextId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerDataUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerDataApi - functional programming interface
 * @export
 */
export const CustomerDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new customer data (with optional TTL).
         * @param {CustomerDataCreate} customerDataCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerData(customerDataCreate: CustomerDataCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDataOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerData(customerDataCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerDataApi.createCustomerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete customer data by ID.
         * @param {number} contextId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomerData(contextId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomerData(contextId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerDataApi.deleteCustomerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all unique attributes from customer data.
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllAttributes(agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string | null>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllAttributes(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerDataApi.getAllAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all customer data (no pagination).
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomerData(agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerDataOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomerData(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerDataApi.getAllCustomerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all unique tags from customer data.
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllTags(agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string | null>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllTags(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerDataApi.getAllTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get paginated list of customer data with filter & sort.
         * @param {string | null} [agentId] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [keyword] 
         * @param {string} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerData(agentId?: string | null, page?: number, pageSize?: number, keyword?: string | null, orderBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCustomerDataOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerData(agentId, page, pageSize, keyword, orderBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerDataApi.getCustomerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get customer data by ID.
         * @param {number} contextId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDataDetail(contextId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDataOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDataDetail(contextId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerDataApi.getCustomerDataDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk import multiple customer data records.
         * @param {Array<CustomerDataImport>} customerDataImport 
         * @param {string | null} [agentId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importCustomerData(customerDataImport: Array<CustomerDataImport>, agentId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importCustomerData(customerDataImport, agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerDataApi.importCustomerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update existing customer data by ID.
         * @param {number} contextId 
         * @param {CustomerDataUpdate} customerDataUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerData(contextId: number, customerDataUpdate: CustomerDataUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDataOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerData(contextId, customerDataUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerDataApi.updateCustomerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerDataApi - factory interface
 * @export
 */
export const CustomerDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerDataApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new customer data (with optional TTL).
         * @param {CustomerDataApiCreateCustomerDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerData(requestParameters: CustomerDataApiCreateCustomerDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDataOut> {
            return localVarFp.createCustomerData(requestParameters.customerDataCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete customer data by ID.
         * @param {CustomerDataApiDeleteCustomerDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomerData(requestParameters: CustomerDataApiDeleteCustomerDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteCustomerData(requestParameters.contextId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all unique attributes from customer data.
         * @param {CustomerDataApiGetAllAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAttributes(requestParameters: CustomerDataApiGetAllAttributesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<string | null>> {
            return localVarFp.getAllAttributes(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all customer data (no pagination).
         * @param {CustomerDataApiGetAllCustomerDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomerData(requestParameters: CustomerDataApiGetAllCustomerDataRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomerDataOut>> {
            return localVarFp.getAllCustomerData(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all unique tags from customer data.
         * @param {CustomerDataApiGetAllTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTags(requestParameters: CustomerDataApiGetAllTagsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<string | null>> {
            return localVarFp.getAllTags(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated list of customer data with filter & sort.
         * @param {CustomerDataApiGetCustomerDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerData(requestParameters: CustomerDataApiGetCustomerDataRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCustomerDataOut> {
            return localVarFp.getCustomerData(requestParameters.agentId, requestParameters.page, requestParameters.pageSize, requestParameters.keyword, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customer data by ID.
         * @param {CustomerDataApiGetCustomerDataDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDataDetail(requestParameters: CustomerDataApiGetCustomerDataDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDataOut> {
            return localVarFp.getCustomerDataDetail(requestParameters.contextId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk import multiple customer data records.
         * @param {CustomerDataApiImportCustomerDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomerData(requestParameters: CustomerDataApiImportCustomerDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.importCustomerData(requestParameters.customerDataImport, requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update existing customer data by ID.
         * @param {CustomerDataApiUpdateCustomerDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerData(requestParameters: CustomerDataApiUpdateCustomerDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDataOut> {
            return localVarFp.updateCustomerData(requestParameters.contextId, requestParameters.customerDataUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createCustomerData operation in CustomerDataApi.
 * @export
 * @interface CustomerDataApiCreateCustomerDataRequest
 */
export interface CustomerDataApiCreateCustomerDataRequest {
    /**
     * 
     * @type {CustomerDataCreate}
     * @memberof CustomerDataApiCreateCustomerData
     */
    readonly customerDataCreate: CustomerDataCreate
}

/**
 * Request parameters for deleteCustomerData operation in CustomerDataApi.
 * @export
 * @interface CustomerDataApiDeleteCustomerDataRequest
 */
export interface CustomerDataApiDeleteCustomerDataRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomerDataApiDeleteCustomerData
     */
    readonly contextId: number
}

/**
 * Request parameters for getAllAttributes operation in CustomerDataApi.
 * @export
 * @interface CustomerDataApiGetAllAttributesRequest
 */
export interface CustomerDataApiGetAllAttributesRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerDataApiGetAllAttributes
     */
    readonly agentId?: string | null
}

/**
 * Request parameters for getAllCustomerData operation in CustomerDataApi.
 * @export
 * @interface CustomerDataApiGetAllCustomerDataRequest
 */
export interface CustomerDataApiGetAllCustomerDataRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerDataApiGetAllCustomerData
     */
    readonly agentId?: string | null
}

/**
 * Request parameters for getAllTags operation in CustomerDataApi.
 * @export
 * @interface CustomerDataApiGetAllTagsRequest
 */
export interface CustomerDataApiGetAllTagsRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerDataApiGetAllTags
     */
    readonly agentId?: string | null
}

/**
 * Request parameters for getCustomerData operation in CustomerDataApi.
 * @export
 * @interface CustomerDataApiGetCustomerDataRequest
 */
export interface CustomerDataApiGetCustomerDataRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerDataApiGetCustomerData
     */
    readonly agentId?: string | null

    /**
     * 
     * @type {number}
     * @memberof CustomerDataApiGetCustomerData
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof CustomerDataApiGetCustomerData
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof CustomerDataApiGetCustomerData
     */
    readonly keyword?: string | null

    /**
     * 
     * @type {string}
     * @memberof CustomerDataApiGetCustomerData
     */
    readonly orderBy?: string
}

/**
 * Request parameters for getCustomerDataDetail operation in CustomerDataApi.
 * @export
 * @interface CustomerDataApiGetCustomerDataDetailRequest
 */
export interface CustomerDataApiGetCustomerDataDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomerDataApiGetCustomerDataDetail
     */
    readonly contextId: number
}

/**
 * Request parameters for importCustomerData operation in CustomerDataApi.
 * @export
 * @interface CustomerDataApiImportCustomerDataRequest
 */
export interface CustomerDataApiImportCustomerDataRequest {
    /**
     * 
     * @type {Array<CustomerDataImport>}
     * @memberof CustomerDataApiImportCustomerData
     */
    readonly customerDataImport: Array<CustomerDataImport>

    /**
     * 
     * @type {string}
     * @memberof CustomerDataApiImportCustomerData
     */
    readonly agentId?: string | null
}

/**
 * Request parameters for updateCustomerData operation in CustomerDataApi.
 * @export
 * @interface CustomerDataApiUpdateCustomerDataRequest
 */
export interface CustomerDataApiUpdateCustomerDataRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomerDataApiUpdateCustomerData
     */
    readonly contextId: number

    /**
     * 
     * @type {CustomerDataUpdate}
     * @memberof CustomerDataApiUpdateCustomerData
     */
    readonly customerDataUpdate: CustomerDataUpdate
}

/**
 * CustomerDataApi - object-oriented interface
 * @export
 * @class CustomerDataApi
 * @extends {BaseAPI}
 */
export class CustomerDataApi extends BaseAPI {
    /**
     * 
     * @summary Create new customer data (with optional TTL).
     * @param {CustomerDataApiCreateCustomerDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataApi
     */
    public createCustomerData(requestParameters: CustomerDataApiCreateCustomerDataRequest, options?: RawAxiosRequestConfig) {
        return CustomerDataApiFp(this.configuration).createCustomerData(requestParameters.customerDataCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete customer data by ID.
     * @param {CustomerDataApiDeleteCustomerDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataApi
     */
    public deleteCustomerData(requestParameters: CustomerDataApiDeleteCustomerDataRequest, options?: RawAxiosRequestConfig) {
        return CustomerDataApiFp(this.configuration).deleteCustomerData(requestParameters.contextId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all unique attributes from customer data.
     * @param {CustomerDataApiGetAllAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataApi
     */
    public getAllAttributes(requestParameters: CustomerDataApiGetAllAttributesRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerDataApiFp(this.configuration).getAllAttributes(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all customer data (no pagination).
     * @param {CustomerDataApiGetAllCustomerDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataApi
     */
    public getAllCustomerData(requestParameters: CustomerDataApiGetAllCustomerDataRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerDataApiFp(this.configuration).getAllCustomerData(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all unique tags from customer data.
     * @param {CustomerDataApiGetAllTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataApi
     */
    public getAllTags(requestParameters: CustomerDataApiGetAllTagsRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerDataApiFp(this.configuration).getAllTags(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated list of customer data with filter & sort.
     * @param {CustomerDataApiGetCustomerDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataApi
     */
    public getCustomerData(requestParameters: CustomerDataApiGetCustomerDataRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerDataApiFp(this.configuration).getCustomerData(requestParameters.agentId, requestParameters.page, requestParameters.pageSize, requestParameters.keyword, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customer data by ID.
     * @param {CustomerDataApiGetCustomerDataDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataApi
     */
    public getCustomerDataDetail(requestParameters: CustomerDataApiGetCustomerDataDetailRequest, options?: RawAxiosRequestConfig) {
        return CustomerDataApiFp(this.configuration).getCustomerDataDetail(requestParameters.contextId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk import multiple customer data records.
     * @param {CustomerDataApiImportCustomerDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataApi
     */
    public importCustomerData(requestParameters: CustomerDataApiImportCustomerDataRequest, options?: RawAxiosRequestConfig) {
        return CustomerDataApiFp(this.configuration).importCustomerData(requestParameters.customerDataImport, requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update existing customer data by ID.
     * @param {CustomerDataApiUpdateCustomerDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataApi
     */
    public updateCustomerData(requestParameters: CustomerDataApiUpdateCustomerDataRequest, options?: RawAxiosRequestConfig) {
        return CustomerDataApiFp(this.configuration).updateCustomerData(requestParameters.contextId, requestParameters.customerDataUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

